import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Marker from './Marker.jsx';
import { ProductHotspotOnce, InteractedOnce, ProductHotspotClicked } from '../../utils/Analytics.js';
import HotspotCircle from './ReactSVGHotspots/HotspotCircle.jsx';
import HotspotPlus from './ReactSVGHotspots/HotspotPlus.jsx';
import { getHotspotIconStyle } from '../../utils/StoreConfigManager';
import ProductModal from '../ui/modals/product/extended-product-modal/ui/ProductModal';

import ProductModalContextComponent from '../ui/modals/product/ProductModalContextComponent.jsx';
import { getIconSVGAsync } from '../ui/ui-layer-panel/SVGIcons.jsx';
const productMarkerHotspot = "https://cdn.obsess-vr.com/umg/pokeball-hotspot-icon.svg";
import { storeId } from '../../../../variables/DevVariables.js';
import { popupStoreId } from '../../utils/StoreConfigManager';
class ProductMarker extends Component {

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
        this.onModalHidden = this.onModalHidden.bind(this);
        this.onProductTitleLoaded = this.onProductTitleLoaded.bind(this);

        this.state = {
            isShowingModal: false,
            svgSprite: null,
            svgSpriteString:''
        };
        this.mounted = false;
        this.productTitle = null;
    }

    componentDidMount() {
        getHotspotIconStyle()
            .then(icon => {
                if(storeId === popupStoreId)
                    this.setPokemonCustomSVGIcon(productMarkerHotspot);
                else{
                    const Sprite = icon == 'blank' ? HotspotCircle : HotspotPlus;
                    this.setState({ svgSprite: Sprite });
                }
            })
            .catch(error => console.error(error));
        this.mounted = true;
    }

    setPokemonCustomSVGIcon(markerIconUrl) {
        getIconSVGAsync(null, markerIconUrl)
        .then(svgString => this.setState({ svgSpriteString: svgString }))
        .catch(error => console.error(error));
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    onProductTitleLoaded(productTitle) {
        this.productTitle = productTitle;
    }

    onClick() {
        if (!this.mounted) {
            return;
        }

        ProductHotspotOnce();
        InteractedOnce();
        if (this.productTitle) {
            ProductHotspotClicked(this.props.productSKU, this.productTitle);
        }
        document.getElementsByTagName('canvas')[0].style.filter='blur(10px)'
        this.setState({ isShowingModal: true });
    }

    onModalHidden() {
        if (!this.mounted) {
            return;
        }
        document.getElementsByTagName('canvas')[0].style.filter='none'
        this.setState({ isShowingModal: false });
    }

    render() {
        const { productSKU, specialUrl } = this.props;
        const { svgSprite,svgSpriteString, isShowingModal} = this.state;

        return (
            <div>
                {isShowingModal && <ProductModalContextComponent ProductSKU={productSKU} onProductTitleLoaded={this.onProductTitleLoaded}>
                    <ProductModal
                        sku={productSKU}
                        onClose={this.onModalHidden}
                        specialUrl={specialUrl}
                    />
                </ProductModalContextComponent>}
            <Marker
                transform={this.props.transform}
                colliderTransform={this.props.colliderTransform}
                svgSprite={svgSprite}
                svgSpriteString={svgSpriteString}
                primaryColor={this.props.primaryColor}
                secondaryColor={this.props.secondaryColor}
                showVisual={this.props.showVisual}
                onClick={this.onClick}
            />
            </div>
        );
    }
}

ProductMarker.propTypes = {
    color: PropTypes.string,
    productSKU: PropTypes.string.isRequired,
    transform: PropTypes.array.isRequired,
    colliderTransform: PropTypes.array.isRequired,
    specialUrl: PropTypes.string,
    primaryColor: PropTypes.string.isRequired,
    secondaryColor: PropTypes.string.isRequired
};

export default ProductMarker;
